// import logo from './logo.svg';
// import './App.css';
// import React, { useEffect, useState } from 'react';
// import axiosInstance from './utils/axiosIntance';

// function Demo() {
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [quntity, setOuntity] = useState(null);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [error, setError] = useState(null);
//   const [imageUrls, setImageUrls] = useState([]);

//   const handleFileChange = (event) => {
//     setSelectedFile(event.target.files[0]);
//   };
  
//   const handleQuantityChange = (event) => {
//   console.log('event :', event.target.value);
//     setOuntity(event.target.value);
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     if (!selectedFile) {
//       alert('Please select a file first!');
//       return;
//     }

//     const formData = new FormData();
//     formData.append('vImage', selectedFile);
//     formData.append('qauntity', quntity);

//     setIsSubmitting(true);
//     setError(null);

//     try {
//       const response = await axiosInstance.post('api/product-variant/uploadImage', formData, {
//         headers: {
//           'Authorization': `Bearer ${localStorage.getItem('accessToken')}`,
//           'Content-Type': 'multipart/form-data',
//         },
//       });
//       // console.log('File uploaded successfully:', response.data);
//       setImageUrls(response.data.data);

//     } catch (err) {
//       console.error('Error uploading file:', err);
//       setError('Failed to upload the file.');
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
//   return (
//     <div>
//       <form onSubmit={handleSubmit}>
//         <input type="file" onChange={handleFileChange} />
//         <input type="number"  onChange={handleQuantityChange}/>
//         <button type="submit" disabled={isSubmitting}>
//           {isSubmitting ? 'Uploading...' : 'Submit'}
//         </button>
//       </form>
//       {error && <p style={{ color: 'red' }}>{error}</p>}

//        {/* Display the images in a grid */}
//        <div className="grid-container">
//         {imageUrls.map((url, index) => (
//             <div class="grid-item">
//               <img key={index} src={`http://localhost:5007/uploads/${url}`} alt={`Uploaded ${index + 1}`} className="uploaded-image"  style={{width: 300, height: 300}}/>
//             </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Demo;


import React, { useState, useEffect } from 'react';

const Demo = () => {
  const [image, setImage] = useState(null);
  const [originalDimensions, setOriginalDimensions] = useState({ width: 0, height: 0 });
  const [dimensions, setDimensions] = useState({ width: '', height: '' });

  const onImageSelect = (e) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      const img = new Image();
      img.src = url;

      img.onload = () => {
        setOriginalDimensions({ width: img.width, height: img.height });
        setDimensions({ width: img.width, height: img.height });
        setImage(url);
      };
    }
  };

  const handleWidthChange = (e) => {
    const newWidth = e.target.value;
    const newHeight = (newWidth / originalDimensions.width) * originalDimensions.height;
    setDimensions({ width: newWidth, height: newHeight });
  };

  const handleHeightChange = (e) => {
    const newHeight = e.target.value;
    const newWidth = (newHeight / originalDimensions.height) * originalDimensions.width;
    setDimensions({ width: newWidth, height: newHeight });
  };

  return (
    <div>
      <input type="file" onChange={onImageSelect} />
      {image && (
        <div>
          <img src={image} alt="Selected" width={dimensions.width} height={dimensions.height} />
          <div>
            <label>
              Width:
              <input
                type="number"
                value={dimensions.width}
                onChange={handleWidthChange}
              />
            </label>
            <label>
              Height:
              <input
                type="number"
                value={dimensions.height}
                onChange={handleHeightChange}
              />
            </label>
          </div>
        </div>
      )}
    </div>
  );
};

export default Demo;
